import { TileLayer } from 'leaflet';
export const basemapGreyLayer: TileLayer = new TileLayer('https://{s}.wien.gv.at/basemap/bmapgrau/normal/google3857/{z}/{y}/{x}.png', {
  subdomains: ['mapsneu'],
  attribution: '&copy; Datenquelle: <a href="http://basemap.at">basemap.at</a>'
});